import { AdminApi } from 'stylemix-vue-admin'

export default class ManagersApi extends AdminApi {
  constructor(parameters) {
    super('managers', parameters)
  }

  assign(userId, config = {}) {
    return this.submit('post', `/${this.endpoint}/${userId}`, null, config)
  }
}
